import Axios from 'axios';

const testEnvironments = ['localhost:8080', 'test01.vcv.team', 'test02.vcv.team', 'test03.vcv.team', 'test04.vcv.team'];

let integrationHost = process.env.INTEGRATION_HOST;

if (testEnvironments.includes(window.location.host)) {
  integrationHost = process.env.INTEGRATION_HOST_TEST;
}

if (window.location.hostname.indexOf('vcv.ai') > 0) {
  integrationHost = process.env.INTEGRATION_HOST_AI;
}

const getDefaultState = () => ({
  isHackerRankLoading: false,
  isHackerRankIntegrationStatus: false,
  integrationInterval: null,
  integrationIntervalCount: 0,
  // vacancy settings
  connectedVacancies: [],
  isConnectionLoading: false,
  hackerRankTests: []
});

const state = getDefaultState();

const getters = {
  isVacancyHackerrankConnected: state => {
    if (state.connectedVacancies.length > 0) {
      if (state.connectedVacancies[0].active) {
        return true;
      }
    }

    return false;
  },

  getHackerrankTestsForSelect: state => {
    return state.hackerRankTests.map(x => {
      return { id: x.id, name: x.title };
    });
  }
};

const mutations = {
  SET_IS_HACKERRANK_LOADING: (state, payload) => {
    state.isHackerRankLoading = payload;
  },

  STOP_INTERVAL_INTEGRATION_CHECK: state => {
    clearInterval(state.integrationInterval);
    state.integrationIntervalCount = 0;
  },

  INCREMENT_INTEGRATION_INTERVAL_COUNT: state => {
    state.integrationIntervalCount += 1;
  },

  SET_INTEGRATION_INTERVAL: (state, payload) => {
    state.integrationInterval = payload;
  },

  SET_HACKERRANK_INTEGRATION_STATUS: (state, payload) => {
    state.isHackerRankIntegrationStatus = payload;
  },

  SET_CONNECTED_VACANCIES: (state, payload) => {
    state.connectedVacancies = payload;
  },

  SET_CONNECTION_LOADING: (state, payload) => {
    state.isConnectionLoading = payload;
  },

  SET_HACKERRANK_TESTS: (state, payload) => {
    state.hackerRankTests = payload;
  },

  RESET_INTEGRATIONS_HEADHUNTER(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  // Периодические запросы к интеграционному сервису чтобы увидеть когда появится access_token в params
  startIntervalIntegrationCheckHackerrank({ commit, dispatch, state }) {
    const integrationInterval = setInterval(() => {
      if (state.integrationIntervalCount <= 6) {
        commit('INCREMENT_INTEGRATION_INTERVAL_COUNT');
        dispatch('grantAccessToHackerrank');
      } else {
        commit('STOP_INTERVAL_INTEGRATION_CHECK');
        commit('SET_IS_HACKERRANK_LOADING', false);
      }
    }, 1000);

    commit('SET_INTEGRATION_INTERVAL', integrationInterval);
  },

  async grantAccessToHackerrank({ commit, dispatch, rootGetters }) {
    // console.log(window.location.host);
    commit('SET_IS_HACKERRANK_LOADING', true);
    commit('SET_HACKERRANK_INTEGRATION_STATUS', false);

    // Запрашиваем список интеграций (в новом списке должен появится access_token для каждой интеграции)
    await dispatch('integrations/fetchIntegrationsInstalls', null, { root: true });

    let apiToken = null; // Это токен который необходимо вернуть и вписать в поле токена в модальное окно после запроса
    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      commit('STOP_INTERVAL_INTEGRATION_CHECK');
    }

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/hackerrank/auth/status`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(async response => {
          commit(
            'integrations/SET_INTEGRATIONS_INSTALLS_STATUS',
            { code: 'hackerrank', value: response.data.ok },
            { root: true }
          );

          if (response.data.ok) {
            apiToken = await Axios.get(`${integrationHost}/v1/hackerrank/company`, {
              headers: { Authorization: `Bearer ${params.access_token}` }
            }).then(response => {
              commit('SET_HACKERRANK_INTEGRATION_STATUS', true);
              commit('STOP_INTERVAL_INTEGRATION_CHECK');
              commit('SET_IS_HACKERRANK_LOADING', false);

              return response.data.hackerrank_api_token;
            });
          } else {
            this._vm.$noty.error(window.$tr('integrations.hackerrank.need-valid-token'));
          }

          commit('SET_IS_HACKERRANK_LOADING', false);
        })
        .catch(() => {
          this._vm.$noty.error(window.$tr('common.error'));
        });
    }

    return apiToken;
  },

  async patchHackerrankApiToken({ commit, rootGetters }, apiToken) {
    commit('SET_IS_HACKERRANK_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      const requestParams = {
        hackerrank_api_token: apiToken
      };

      await Axios.patch(`${integrationHost}/v1/hackerrank/company`, requestParams, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          if (response.data.active) {
            this._vm.$noty.success(window.$tr('integrations.token-accepted'));
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this._vm.$noty.error(window.$tr('integrations.token-invalid'));
          }
        })
        .finally(() => {
          commit('SET_IS_HACKERRANK_LOADING', false);
        });
    }
  },

  // vacancy section
  async checkExistingConnection({ commit, rootGetters }, vacancyId) {
    commit('SET_CONNECTION_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/hackerrank/vacancies?with[]=tests&filter[vcv_vacancy_id]=${vacancyId}`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_CONNECTED_VACANCIES', response.data._embedded.vacancies);
        })
        .catch(() => {
          this._vm.$noty(window.$tr('common.error'));
        })
        .finally(() => {
          commit('SET_CONNECTION_LOADING', false);
        });
    }
  },

  async toggleHackerrankToVacancy({ commit, dispatch, state, rootGetters }, vacancyId) {
    commit('SET_CONNECTION_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      // Если вакансий прикрепленных нет, то нет и связи. Значит связь создаем через POST и автоматически она включается.
      if (state.connectedVacancies.length === 0) {
        const params = {
          active: true,
          vcv_vacancy_id: vacancyId
        };

        await Axios.post(`${integrationHost}/v1/hackerrank/vacancies`, params, {
          headers: { Authorization: `Bearer ${params.access_token}` }
        })
          .then(() => {
            dispatch('checkExistingConnection');
          })
          .catch(() => {
            this._vm.$noty(window.$tr('common.error'));
          })
          .finally(() => {
            commit('SET_CONNECTION_LOADING', false);
          });
      } else {
        // В остальных случаях меняем патчем значение active
        const currentConnect = state.connectedVacancies.find(x => x.vcv_vacancy_id === vacancyId);
        const params = {
          active: !currentConnect.active
        };

        await Axios.patch(`${integrationHost}/v1/hackerrank/vacancies/${currentConnect.id}`, params, {
          headers: { Authorization: `Bearer ${params.access_token}` }
        })
          .catch(() => {
            this._vm.$noty(window.$tr('common.error'));
          })
          .then(() => {
            dispatch('checkExistingConnection');
          });
      }
    }
  },

  async fetchHackerrankTests({ commit, rootGetters }) {
    commit('SET_CONNECTION_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/hackerrank/tests?limit=250`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_HACKERRANK_TESTS', response.data._embedded.tests);
        })
        .finally(() => {
          commit('SET_CONNECTION_LOADING', false);
        });
    }
  },

  // payload.vacancyId, payload.tests array
  async saveHackerrankTests({ commit, rootGetters }, payload) {
    commit('SET_CONNECTION_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('hackerrank');

    if (params.access_token) {
      const currentConnect = state.connectedVacancies.find(x => x.vcv_vacancy_id === payload.vacancyId);
      const params = {
        active: currentConnect.active,
        _embedded: { tests: payload.tests }
      };

      await Axios.patch(`${integrationHost}/v1/hackerrank/vacancies/${currentConnect.id}?with[]=tests`, params, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_HACKERRANK_TESTS', response.data._embedded.tests);
        })
        .finally(() => {
          commit('SET_CONNECTION_LOADING', false);
        });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
